































































import { Vue, Component } from 'vue-property-decorator'
import userStore from '@/modules/auth/auth.store'
import matchStore from '@/modules/match/match.store'
import { getModule } from 'vuex-module-decorators'
import { getRealtimeConnection } from '@/utils/realtime'
import { HubConnection } from '@microsoft/signalr'
import { CancelError, CancellationToken } from '@/utils/cancel'

export interface MatchEndedResponse {
  winners: string[]
  isDraw: boolean
}

@Component
export default class MatchCompleteDialog extends Vue {
  userModule = getModule(userStore, this.$store)
  matchModule = getModule(matchStore, this.$store)
  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()

  isVisible: boolean = false
  winners: string[] = []
  isDraw: boolean = false

  get winnerString(): string {
    return this.winners.join(', ')
  }

  async created() {
    try {
      this.realtimeConnection = await getRealtimeConnection(
        this.realtimeConnectionCancellationToken
      )
    } catch (err) {
      if (err instanceof CancelError) {
        return
      }

      this.$toast.error(this.$t('MatchCompleteDialog.FailConnectServerMessage'))
      console.error(err)
    }

    this.realtimeConnection.on('matchComplete', this.onMatchComplete)
  }

  beforeDestroy() {
    this.realtimeConnectionCancellationToken.cancel()

    if (this.realtimeConnection) {
      this.realtimeConnection.off('matchComplete', this.onMatchComplete)
    }
  }

  async onMatchComplete(payload: MatchEndedResponse) {
    if (!this.matchModule.matchGame) {
      return
    }

    const winners = []

    for (const matchTeamId of payload.winners) {
      const winner = this.matchModule.matchGame.teams.find(
        team => team.matchTeamId === matchTeamId
      )

      if (winner) {
        winners.push(winner.name)
      }
    }

    this.winners = winners
    this.isDraw = payload.isDraw
    this.isVisible = true

    try {
      const matchGameId = await this.matchModule.fetchMatch(
        this.matchModule.match!.matchId
      )
      await this.matchModule.fetchMatchGame(
        this.matchModule.matchGame!.matchGameId
      )
    } catch {
      // something happens
      await this.$router.push('/')
    }
  }
}
